import {FC, useMemo} from "react";
import {OfficeModalProps} from "../../../types/office";
import {Modal, Spin} from "antd";
import OfficeForm from "./components/office-form/OfficeForm";


const OfficeModal: FC<OfficeModalProps> = (props) => {
  const {officesController} = props
  const {isCreateModalOpen, officeForm, selectedOffice, toggleCreateModalVisible, isLoading} = officesController
  const title = useMemo(() => {
    return selectedOffice ? `Редагування кабінету ${selectedOffice.name}` : 'Створення кабінету'
  }, [selectedOffice])
  return <Modal width={1000} centered title={title} open={isCreateModalOpen} onOk={() => {
    officeForm.submit()
  }}
                onCancel={toggleCreateModalVisible}
                cancelButtonProps={{title: "Закрити"}} okButtonProps={{children: "Зберегти"}}>
    <Spin spinning={isLoading}>
      <OfficeForm officesController={officesController}/>
    </Spin>
  </Modal>
}

export default OfficeModal